import { owcTheme } from 'core/theme/theme.config';
import styled from 'styled-components';

export const ActiveDirectoryStatusBaseContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    owc-icon {
        padding-right: 5px;
        color: ${owcTheme['one-color-interaction-default-intensity-medium']};
    }
`;
